/* URBAN V10. Reversible scroll time, original-photo parallax and static fallbacks. */
(() => {
  'use strict';
  if (window.TZ_URBAN_STUDY) return;
  window.TZ_URBAN_STUDY = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const allowed = () => !reduced.matches && !navigator.connection?.saveData;
  const clamp = n => Math.max(0, Math.min(1, n));
  const smooth = n => { n = clamp(n); return n * n * (3 - 2 * n); };
  const records = [...document.querySelectorAll('[data-urban-study]')].map(root => ({root,stage:root.querySelector('.us-stage'),scenes:[...root.querySelectorAll('[data-study-scene]')],video:root.querySelector('video'),p:0,near:false}));
  let raf = 0;
  function seek(r) {
    const v=r.video;
    if(!v || !allowed() || document.hidden || v.readyState<1 || !Number.isFinite(v.duration) || v.seeking)return;
    const time=r.p*Math.max(0,v.duration-.06);
    if(Math.abs(v.currentTime-time)>.05){try{v.currentTime=time;}catch{ /* Poster remains usable. */ }}
  }
  function load(r) {
    if(!r.video || !allowed())return;
    const src=mobile.matches&&r.video.dataset.mobile?r.video.dataset.mobile:r.video.dataset.desktop;
    if(!src || r.video.getAttribute('src')===src)return;
    r.root.classList.remove('has-video');r.video.preload='auto';r.video.src=src;r.video.load();
  }
  function draw() {
    raf=0;
    records.forEach(r=>{
      const rect=r.root.getBoundingClientRect();
      if(!allowed() || document.hidden || rect.bottom<0 || rect.top>innerHeight)return;
      r.p=clamp(-rect.top/Math.max(1,rect.height-r.stage.clientHeight));r.root.dataset.progress=r.p.toFixed(4);
      r.root.style.setProperty('--us-light-x',`${(r.p-.5)*90}px`);
      const count=r.scenes.length,position=r.p*count,current=Math.min(count-1,Math.floor(position+.22));
      r.scenes.forEach((scene,i)=>{
        const start=i===0?0:i-.22, end=i===count-1?count:i+.78;
        const fadeIn=i===0?1:smooth((position-start)/.22);
        const fadeOut=i===count-1?1:1-smooth((position-end)/.22);
        const opacity=Math.min(fadeIn,fadeOut),local=clamp((position-i+.22)/1.22);
        scene.style.opacity=opacity.toFixed(4);scene.style.visibility=opacity>.001?'visible':'hidden';
        scene.classList.toggle('is-current',i===current);scene.setAttribute('aria-hidden',String(i!==current));scene.inert=i!==current;
        scene.style.setProperty('--us-scale',String(1+smooth(local)*(mobile.matches ? .055 : .08)));
        scene.style.setProperty('--us-turn',`${(local-.5)*(mobile.matches?1.6:4)}deg`);
        scene.style.setProperty('--us-x',`${(local-.5)*(mobile.matches?6:24)}px`);
        scene.style.setProperty('--us-y',`${(local-.5)*-16}px`);
        scene.style.setProperty('--us-z',`${smooth(local)*28}px`);
        scene.style.setProperty('--us-copy-y',`${(1-smooth(local))*8}px`);
      });
      seek(r);
    });
  }
  function schedule(){if(!raf&&!document.hidden)raf=requestAnimationFrame(draw);}
  const near=new IntersectionObserver(entries=>entries.forEach(e=>{const r=records.find(x=>x.root===e.target);r.near=e.isIntersecting;if(r.near)load(r);schedule();}),{rootMargin:'60% 0px'});
  records.forEach(r=>{near.observe(r.root);if(r.video){r.video.addEventListener('loadedmetadata',()=>{seek(r);schedule();});r.video.addEventListener('loadeddata',()=>{r.root.classList.add('has-video');schedule();});r.video.addEventListener('seeked',()=>seek(r));r.video.addEventListener('error',()=>r.root.classList.remove('has-video'));}});
  function mode(){records.forEach(r=>{r.root.classList.toggle('is-enhanced',allowed());r.root.dataset.motion=allowed()?'scroll':'static';r.scenes.forEach(s=>{s.removeAttribute('style');s.removeAttribute('aria-hidden');s.inert=false;});r.video?.pause();if(r.near)load(r);});schedule();}
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',()=>{records.filter(r=>r.near).forEach(load);schedule();},{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){if(raf)cancelAnimationFrame(raf);raf=0;}else schedule();});
  reduced.addEventListener('change',mode);new ResizeObserver(schedule).observe(document.body);mode();
})();
